import { createApp } from 'vue';

import CommunityListings from '../components/community/community-listings.vue';

// Mounts the community listings section rendered by templates/_communities/community.twig.
const app = createApp(CommunityListings);

app.config.compilerOptions.whitespace = 'preserve';
app.mount('#community-listings');
